export default "__VITE_PUBLIC_ASSET__fc8b3ce4__"